import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { upload } from "../../../../controllers/import/index";

export const UPLOAD_XLSX_DOCUMENT_REQUEST = 'UPLOAD_XLSX_DOCUMENT_REQUEST';
export const UPLOAD_XLSX_DOCUMENT_SUCCESS = 'UPLOAD_XLSX_DOCUMENT_SUCCESS';
export const UPLOAD_XLSX_DOCUMENT_FAILURE = 'UPLOAD_XLSX_DOCUMENT_FAILURE';
export const UPLOAD_XLSX_DOCUMENT = 'UPLOAD_XLSX_DOCUMENT';

interface ActionDefault<T> {
    type : string,
    payload  : T
}

interface ActionPagination<T> {
    type : string,
    payload  : T
}

const uploadXlsxDocumentRequest = () => {
    return {
        type: UPLOAD_XLSX_DOCUMENT_REQUEST,
    };
};

const uploadXlsxDocumentSuccess = (data: any):ActionPagination<Result<any>> => {
    return {
        type: UPLOAD_XLSX_DOCUMENT_SUCCESS,
        payload :data
    };
};

const uploadXlsxDocumentFailure = (error: any) => {
    return {
        type: UPLOAD_XLSX_DOCUMENT_FAILURE,
        payload: error,
    };
};
const uploadXlsx = (data:any) => {
    return {
        type: UPLOAD_XLSX_DOCUMENT,
        payload: data,
    };
}

export const ImportFromXlsx = (file:File, uploadType:string)=>  {
    return async (dispatch: Dispatch<AnyAction>) => {
         dispatch(uploadXlsxDocumentRequest());
         try {
            const response = await upload(file, uploadType);
            dispatch(uploadXlsxDocumentSuccess(response.data));
         } catch (error:any) {
             dispatch(uploadXlsxDocumentFailure(error.message));
         }
     };
 };
